/* Ported from src/pages/ContactPage.tsx — mailto submit, same pattern as the expertise form. */
(function () {
  function init(form) {
    var submitLabel = form.querySelector('oblivion-descramble');

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var name = form.querySelector('[name="name"]').value;
      var email = form.querySelector('[name="email"]').value;
      var message = form.querySelector('[name="message"]').value;

      var subject = encodeURIComponent('Contact Oblivion — ' + (name || 'Nouveau message'));
      var body = encodeURIComponent(message + '\n\n— ' + name + ' (' + email + ')');
      window.location.href = 'mailto:Oblivionintercom@support.fr?subject=' + subject + '&body=' + body;
      if (submitLabel) submitLabel.textContent = 'CLIENT MAIL OUVERT';
    });
  }

  document.querySelectorAll('[data-oblivion-contact-form]').forEach(init);
})();
